import { render, staticRenderFns } from "./plan-item-1.vue?vue&type=template&id=25f94c2b&scoped=true&"
import script from "./plan-item-1.vue?vue&type=script&lang=js&"
export * from "./plan-item-1.vue?vue&type=script&lang=js&"
import style0 from "./plan-item-1.vue?vue&type=style&index=0&id=25f94c2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f94c2b",
  null
  
)

export default component.exports